export default items => {
    const lettersOccurCount = [];

    items.forEach(item => {
        const itemNameFirstLetter = item[0].charAt(0);
        const letterPresentInArray = lettersOccurCount.find(letter => letter.name === itemNameFirstLetter);

        letterPresentInArray
            ? letterPresentInArray.count++
            : lettersOccurCount.push({
                  name: itemNameFirstLetter,
                  count: 1
              });
    });

    return lettersOccurCount;
};
